module.exports = {"StatusCode":200,"Payload":[{"paymentMethod":true}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/updatePayment.json
// module id = tKww
// module chunks = 0